import React from "react";

function EmptyEngagement() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#efedff"
        d="M256 123.622L61.811 185.433v202.946C61.811 456.653 117.158 512 185.433 512H450.19c34.136 0 61.81-27.674 61.81-61.811V185.433z"
        data-original="#efedff"
      ></path>
      <path
        fill="#d4d4ff"
        d="M123.622 450.189V185.433l-61.811-30.905L0 185.433V450.19C0 484.326 27.674 512 61.811 512h123.622c-34.138 0-61.811-27.674-61.811-61.811z"
        data-original="#d4d4ff"
      ></path>
      <path
        fill="#ff8e9e"
        d="M512 123.622c0-34.137-27.674-61.811-61.811-61.811H123.622l-61.811 61.811 61.811 61.811H512z"
        data-original="#ff8e9e"
      ></path>
      <path
        fill="#ea5b70"
        d="M61.811 61.811C27.674 61.811 0 89.485 0 123.622v61.811h123.622c0-18.481 4.061-36.011 11.332-51.755V61.811z"
        data-original="#ea5b70"
      ></path>
      <path
        fill="#d4d4ff"
        d="M398.68 154.527c-17.068 0-30.905-13.837-30.905-30.905V30.905C367.775 13.837 381.612 0 398.68 0s30.905 13.837 30.905 30.905v92.716c.001 17.069-13.836 30.906-30.905 30.906zM114.35 0C97.282 0 83.445 13.837 83.445 30.905v92.716a30.765 30.765 0 007.281 19.919c5.669 6.715 14.148 10.987 23.624 10.987 17.068 0 30.905-13.837 30.905-30.905V30.905C145.256 13.837 131.419 0 114.35 0z"
        data-original="#d4d4ff"
      ></path>
      <path
        fill="#313d40"
        d="M320.333 115.428a7.725 7.725 0 00-7.726 7.726v12.362a7.726 7.726 0 1015.452 0v-12.362a7.725 7.725 0 00-7.726-7.726zm-121.09-12.291c-4.557 2.738-10.597 2.738-15.154 0a7.726 7.726 0 10-7.958 13.246 30.084 30.084 0 008.558 3.467 7.693 7.693 0 00-.749 3.303v12.362a7.725 7.725 0 007.726 7.726 7.725 7.725 0 007.726-7.726v-12.362a7.695 7.695 0 00-.749-3.304 30.037 30.037 0 008.557-3.467 7.726 7.726 0 002.644-10.602c-2.195-3.657-6.943-4.84-10.601-2.643zm76.641 32.585c-12.468-5.098-28.687-5.126-36.587-5.126h-.259a7.726 7.726 0 100 15.452h.238c6.39 0 21.09.023 30.76 3.977 3.966 1.622 8.468-.296 10.075-4.228a7.724 7.724 0 00-4.227-10.075z"
        data-original="#313d40"
      ></path>
    </svg>
  );
}

export default EmptyEngagement;